module.exports = __webpack_public_path__ + "img/soldout.ac341a99.png";